export default "__VITE_ASSET__89969d1d__"